
import React, { useState, useEffect } from 'react';
import { TextInput, Button } from 'carbon-components-react';
import { AddAlt16 } from '@carbon/icons-react';
import i18n from "../../i18n";
import "global.scss";
require("./_add-duration.scss");



const AddDuration = (props) => {
    let user = JSON.parse(localStorage.getItem('user'));
    // const [numberOfTasks, setNumberOfTasks] = useState(1);
    const [numberOfAutomata, setNumberOfAutomata] = useState(1);

    //const AddTask = i18n.t('manageschedule.AddTask');
    //const SaveTask = i18n.t('manageschedule.SaveTask');
    const validValue = i18n.t('manageschedule.validValue');
    const ExecutionTime = i18n.t('manageschedule.ExecutionTime');
    const Task = i18n.t('manageschedule.Task');
    // function renderNewAutomata() {
    //     let count = props.currentAutomata.length;
    //     count = count + 1;
    //     setNumberOfAutomata(count)
    // }
    // useEffect(() => {
    //     props.renderNewAutomata()
    // }, [props.numberOfAutomata])
    // function renderNewTask() {
    //     let count = numberOfTasks;
    //     count = count + 1;
    //     setNumberOfTasks(count)
    // }
    if (user !== null && user.access_token !== null) {
        return (
            <>
                <div className="add-duration">
                    <div className="bx--grid">
                        {Array.apply(null, { length: props.tasksArray.length }).map((e, i) => (

                            <div className="bx--row task-name carbon-display-Semibold-16">
                                <div className="bx--col bx--col-sm-4">
                                    <div className="task-id">
                                        {Task} {i + 1}
                                    </div>
                                </div>
                                {Array.apply(null, { length: props.tasksArray[i].automataArray.length }).map((e, j) => (
                                    <div className="bx--row automata">
                                        <div className="bx--col bx--col-sm-4 carbon-display-Regular-14">
                                            {props.tasksArray[i].automataArray.length > 0 && props.tasksArray[i].automataArray[j] && props.tasksArray[i].automataArray[j].key.length > 20 ? props.tasksArray[i].automataArray[j].key.substr(0, 16) + '\n' + props.tasksArray[i].automataArray[j].key.substr(17, 23) : props.tasksArray[i].automataArray[j].key}
                                            {/* Automata {j} */}
                                        </div>
                                        <div className="bx--col bx--col-sm-4">
                                            <TextInput
                                                disabled={props.review}
                                                id={"time" + i}
                                                invalidText={validValue}
                                                placeholder="Eg. 10"
                                                className="recommended-dropdown"
                                                labelText={ExecutionTime}
                                                // value={props.time}
                                                value={props.tasksArray[i].automataArray[j].timeDelay}
                                                onMouseOut={(e) => props.handleSubmit(e, i, j)}
                                                onChange={(e) => props.handleTime(e, i, j)}
                                            />
                                        </div>
                                        <div className="bx--col bx--col-sm-4 completion-box">
                                            {/* <TextInput
                                                id={"delay" + i}
                                                invalidText="A valid value is required"
                                                placeholder="Eg: 10"
                                                labelText="Post completion delay (in secs)"
                                                value={props.tasksArray[i].automataArray[j].time}
                                                // value={props.timeDelay}
                                                onChange={(e) => props.handleTimeDelay(e,i,j)}
                                            /> */}
                                        </div>
                                        <div className="bx--col bx--col-sm-4 action-button">
                                            {/* <Button kind="ghost" renderIcon={AddAlt16} onClick={props.renderNewAutomata}></Button> */}
                                        </div>
                                    </div>

                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            </>
        )
    } else {
        return (
            <div>
                <h2>{i18n.t('editScheduleRecommendation.please')}<a href={`https://development.aocc-staging-lon02-b3c-7dced0308bf9da27b6e714d1d05f7137-0000.eu-gb.containers.appdomain.cloud/login`}> {i18n.t('editScheduleRecommendation.signup')} </a> </h2>
            </div>
        );
    }

}

export default AddDuration